import { useRef } from 'react';

import { useLazy } from '@/domains/core/page/hooks/useLazy';

export const useElementRef = () => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const { hasBeenDisplayed } = useLazy(elementRef);
  return {
    hasBeenDisplayed,
    elementRef,
  };
};
